var exports = {
  "w": "xfb577c5e--2b0154--header",
  "n": "xfb577c5e--2b0154--controls",
};

module.exports = exports;
